import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  FormControl,
  Grid,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import ApiEndpoints from "../network/ApiEndPoints";
import { postJsonData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import Loader from "../component/loading-screen/Loader";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";

const EditUserKey = ({ open, handleClose, data, onSuccess }) => {
  const [request, setRequest] = useState(false);
  const [ips, setIps] = useState([]);

  // 🔹 Prefill IPs (comma separated → array)
  useEffect(() => {
    if (data?.ip) {
      setIps(data.ip.split(","));
    } else {
      setIps([""]);
    }
  }, [data]);

  // 🔹 Update IP value
  const handleIpChange = (index, value) => {
    const updatedIps = [...ips];
    updatedIps[index] = value;
    setIps(updatedIps);
  };

  // 🔹 Add new IP field
  const addIpField = () => {
    setIps([...ips, ""]);
  };

  // 🔹 Remove IP field (keep at least one)
  const removeIpField = (index) => {
    if (ips.length === 1) return; // 🚫 at least one IP required
    const updatedIps = ips.filter((_, i) => i !== index);
    setIps(updatedIps);
  };

  // 🔹 Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: data.id,
      ip: ips.filter(Boolean).join(","), // comma separated
    };

    postJsonData(
      ApiEndpoints.UPDATE_USER_KEYS,
      payload,
      setRequest,
      (res) => {
        okSuccessToast(res?.data?.message);
        // onSuccess();
      },
      (err) => apiErrorToast(err)
    );
  };

  if (!data) return null;

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box sx={{ width: 400 }} className="sm_modal">
        <Loader loading={request} />
        <ModalHeader title="Edit User Key" handleClose={handleClose} />

        <Box
          component="form"
          id="editUserKeyForm"
          onSubmit={handleSubmit}
          sx={{ "& .MuiTextField-root": { m: 2 } }}
        >
          <Grid container>
            {/* USER ID */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  label="User ID"
                  value={data.user_id}
                  size="small"
                  disabled
                />
              </FormControl>
            </Grid>

            {/* IP FIELDS */}
            {ips.map((ip, index) => (
              <Grid
                item
                xs={12}
                key={index}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <FormControl fullWidth>
                  <TextField
                    label={`IP Address ${index + 1}`}
                    size="small"
                    value={ip}
                    onChange={(e) => handleIpChange(index, e.target.value)}
                    required={index === 0}
                  />
                </FormControl>

                {/* REMOVE BUTTON */}
                <Tooltip title="Remove IP">
                  <IconButton
                    onClick={() => removeIpField(index)}
                    color="error"
                    sx={{ mt: 2 }}
                    disabled={ips.length === 1}
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            ))}

            {/* ADD IP BUTTON */}
            <Grid item xs={12}>
              <Tooltip title="Add IP">
                <IconButton
                  onClick={addIpField}
                  sx={{ ml: 1, mt: 1 }}
                  color="primary"
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mr: 2 }}>
          <ModalFooter
            form="editUserKeyForm"
            type="submit"
            btn="Update"
            disable={request}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default EditUserKey;
